<template>
    <div class="scene">
        <variation-select
            v-if="hasVariations"
            :options="variationNames"
            :default="variationNames[variationIndex]"
            @input="selectVariation($event)"
        />
        <perspective-viewport>
            <skybox />
            <interaction />
            <model
                :model="modelInside"
                side="left"
                :hotspots="onLoadHotspots"
            ></model>
            <model
                :model="modelOutside"
                side="right"
                :hotspots="onLoadHotspots"
            ></model>
        </perspective-viewport>
    </div>
</template>

<script>
import { HemisphereLight, AmbientLight, DirectionalLight } from 'three';
import { mapState, mapActions } from 'vuex';
import collect from 'collect.js';
import PerspectiveViewport from './perspective-viewport';
import Interaction from './interaction';
import Model from './model';
import Skybox from './skybox';
import VariationSelect from '../variation-select';

export default {
    props: ['model'],
    components: {
        PerspectiveViewport,
        Interaction,
        Model,
        Skybox,
        VariationSelect
    },
    data() {
        return {
            variationIndex: 0
        };
    },
    computed: {
        ...mapState('spinner', [
            'sceneLeft',
            'sceneRight',
            'camera',
            'loadFinished'
        ]),
        modelInside() {
            if (this.hasVariations) {
                return `models\\${this.model.models[this.variationIndex].in}`;
            } else {
                return this.model ? `models\\${this.model.models.in}` : '';
            }
        },
        modelOutside() {
            if (this.hasVariations) {
                return `models\\${this.model.models[this.variationIndex].out}`;
            } else {
                return this.model ? `models\\${this.model.models.out}` : '';
            }
        },
        hasVariations() {
            return (
                this.model &&
                this.model.models &&
                this.model.models instanceof Array
            );
        },
        variations() {
            return this.hasVariations ? this.model.models : [this.model.models];
        },
        variationNames() {
            return this.hasVariations
                ? collect(this.model.models)
                      .pluck('variation')
                      .all()
                : [];
        }
    },
    mounted: function() {
        this.$nextTick(() => {
            let hemi = new HemisphereLight(0xffffff, 0x999900, 1);
            this.sceneLeft.add(hemi);
            this.sceneRight.add(hemi.clone());
            const ambient = new AmbientLight(0xffffff, 1);
            this.sceneLeft.add(ambient);
            this.sceneRight.add(ambient.clone());
            const directionalLight = new DirectionalLight(0xffffff, 5);
            directionalLight.position.copy(this.camera.position);
            directionalLight.target.position.set(0, 0, 0);
            // const helper = new DirectionalLightHelper(
            //     directionalLight,
            //     5,
            //     0xff0000
            // );
            // this.sceneRight.add(helper);
            // this.sceneRight.add(directionalLight);
            this.camera.add(directionalLight);
        });
    },
    methods: {
        ...mapActions('spinner', ['loadHotspots']),
        onLoadHotspots(hotspots, side, empty) {
            // eslint-disable-next-line no-console
            console.log('loading hotspots', hotspots);
            this.loadHotspots({ hotspots, side, empty });
        },
        selectVariation(name) {
            this.variationIndex = collect(this.variations).search(
                item => item.variation === name
            );
        }
    }
};
</script>

<style lang="scss">
.viewport-container,
.viewport,
.layer3D {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
}

canvas {
    image-rendering: optimizeSpeed;
    image-rendering: crisp-edges;
    image-rendering: optimize-contrast;
    image-rendering: pixelated;
}
</style>
